const common = require("lib/labels/_common");

// Home.group.services

module.exports = {
  serviceList: {
    title: {
      en: "Bases",
      fr: "Bases"
    },
    title_delete_check: common.title_delete_check,
    content_delete_check: common.content_delete_check,
    no: common.no,
    yes: common.yes,
    edit: common.edit,
    remove: common.remove,
    detailed: {
      key: {
        en: "Unique Key",
        fr: "Clé unique"
      },
      app: {
        en: "App",
        fr: "App"
      },
      databaseName: {
        en: "Database",
        fr: "Base de donnée"
      },
      appName: {
        en: "App",
        fr: "App"
      },
      appVersion: {
        en: "App's version",
        fr: "Version de l'application"
      },
      initialized: {
        en: "Yes",
        fr: "Oui"
      },
      notInitialized: {
        en: "No",
        fr: "Non"
      },
      storage: {
        en: "Storage",
        fr: "Stockage"
      }
    }
  },
  serviceForm: {
    stepTitle: {
      en: "Base",
      fr: "Base"
    },
    title: {
      edition: {
        en: "Edit database",
        fr: "Edition de la base de donnée"
      },
      creation: {
        en: "Base creation",
        fr: "Création de base"
      }
    },
    app: {
      en: "App",
      fr: "App"
    },
    appVersion: {
      en: "App's version",
      fr: "Version de l'application"
    },
    key: {
      en: "Unique key",
      fr: "Clé unique"
    },
    name: {
      en: {
        en: "English name",
        fr: "Nom anglais"
      },
      fr: {
        en: "French name",
        fr: "Nom français"
      }
    },
    errName: {
      en: ""
    },
    service: common.service,
    testName: {
      en: "This name already exists",
      fr: "Nom déjà utilisé"
    },
    testKey: {
      en: "Characters not allowed",
      fr: "Caractère(s) non autorisé(s)"
    },
    keyAlreadyExisting: {
      en: "This key already exists",
      fr: "Clé déjà utilisé"
    }
  }
};
